import { Link } from 'react-router-dom';
import { useAvailability } from '../../lib/content';
import { ArrowRightIcon, LockIcon } from '../icons';
import { ChatMockup } from './ChatMockup';
import { HeroOrb } from './HeroOrb';
import { StatusPill } from './primitives';

const shortHour = (value: string): string => value.replace(/^0/, '');

export function Hero() {
  const { data: availability } = useAvailability();
  const lawyersAvailable = availability
    ? availability.online || availability.onShift > 0
    : true;
  const hoursLabel = `Ежедневно ${shortHour(availability?.workHoursStart ?? '09:00')}–${shortHour(
    availability?.workHoursEnd ?? '21:00'
  )} по Москве`;

  return (
    <section className="relative overflow-hidden px-4 pb-14 pt-[70px] md:px-8 md:pb-20 md:pt-[70px] lg:pt-[50px] xl:px-20">
      <div className="relative z-10 mx-auto grid max-w-[1280px] items-start gap-12 lg:grid-cols-2 lg:gap-10 xl:grid-cols-[minmax(0,1fr)_minmax(0,700px)] xl:gap-8">
        <div className="flex w-full max-w-[548px] flex-col items-start gap-5">
          <StatusPill tone="blue" className="min-w-[153px] pl-3">Помощь онлайн</StatusPill>
          <h1 className="max-w-[548px] text-[34px] font-semibold leading-[1.1] tracking-[-0.024em] text-black sm:text-[42px] md:text-[52px] md:leading-[58px]">
            Юридическая помощь призывникам и военнослужащим
          </h1>
          <p className="max-w-[500px] text-[16px] leading-[1.5] text-muted md:text-[18px] md:leading-[27px]">
            Онлайн-чат с юристом: отсрочки, выплаты, медицинские вопросы и обжалование решений.
            Отвечаем понятно и по делу.
          </p>
          <StatusPill
            tone={lawyersAvailable ? 'green' : 'white'}
            className="w-[288px] pl-3"
          >
            {lawyersAvailable ? hoursLabel : 'Ответим в ближайшее рабочее время'}
          </StatusPill>
          <div className="flex max-w-[361px] items-start gap-2 text-[14px] leading-[18px] text-muted">
            <LockIcon className="h-4 w-4 shrink-0" />
            <span>Конфиденциально. Доступ только у вас и юриста.</span>
          </div>
          <Link
            to="/#how-it-works"
            className="inline-flex items-center gap-1.5 text-[15px] font-semibold leading-[19px] text-accent hover:opacity-80"
          >
            Как это работает
            <ArrowRightIcon className="h-4 w-4" />
          </Link>
        </div>

        <div className="relative pt-[70px]">
          <HeroOrb className="pointer-events-none absolute right-[70px] top-0 z-0 w-[260px] max-w-[364px] sm:w-[320px] lg:w-[364px]" />
          <ChatMockup />
        </div>
      </div>
    </section>
  );
}
